"use client";
import { getServiceConfig } from "@/config/serviceConfig";
import { store } from "@/store/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PropsWithChildren, useEffect, useState } from "react";
import { PermissionProvider } from "@/contexts/PermissionContext";
import { Provider } from "react-redux";
import { UiContextProvider } from "@/features/page_agent/shared/context/UiContext";
import { AgentThreadProvider } from "@/features/page_agent/shared/context/AgentThreadContext";
import { AgentCapabilityProvider } from "@/features/page_agent/shared/context/AgentCapabilityContext";

const LayoutConfig = () => {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   const config = generateLayoutConfig();
  //   dispatch(setLayoutConfig(config));
  // }, []);
  return null;
};

export function Providers({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0,
            gcTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  useEffect(() => {
    // Eager load service configuration on app boot
    getServiceConfig().catch(console.error);
  }, []);

  return (
    <Provider store={store}>
      <LayoutConfig />
      <QueryClientProvider client={queryClient}>
        <UiContextProvider>
          <AgentCapabilityProvider>
            <AgentThreadProvider>
              <PermissionProvider>{children}</PermissionProvider>
            </AgentThreadProvider>
          </AgentCapabilityProvider>
        </UiContextProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </Provider>
  );
}
